<div class="card-container">
    <app-tabs [tabs]="remarkTabs()" [selectedIndex]="selectedTabIndex()" (tabChange)="onTabChange($event)"
        class="remark-tabs">
    </app-tabs>

    @if (isRemarksTabSelected()) {
    <div class="remarks-section">
        <div class="remarks-search-container">
            <app-input [formGroup]="searchForm" [controlName]="'search'" [placeholder]="'Search remarks'" [isSearchIcon]="true"
                [isClearIcon]="true" [label]="''">
            </app-input>
        </div>

        @if (filteredRemarks().length === 0) {
        <div class="empty-state">
            <span>No remarks found</span>
        </div>
        } @else {
        <div class="timeline">
            @for (item of filteredRemarks(); track $index; let last = $last) {
            <div class="timeline-item" [class.last]="last">

                <!-- Left Rail -->
                <div class="timeline-rail">
                    <span class="dot"></span>
                    <span class="line"></span>
                </div>

                <!-- Right Content -->
                <div class="timeline-content">

                    <div class="timeline-header">
                        <span class="date">
                            {{ formatDate(item.createdOnDate || item.createdOn || '') }}
                        </span>
                        <div class="dot"></div>
                        <span class="time">
                            {{ item.displayTime || formatTime(item.createdOnDate || item.createdOn || '') }}
                        </span>

                        <app-tooltip class="actor-img" [position]="'above'" [showDelay]="80" [hideDelay]="0">
                            <img src="assets/images/generic-agent.svg" class="avatar" alt="User avatar" />
                            <ng-template #tooltipContent>
                                <div class="user-details">
                                    <span class="user-name">{{ item.createdUserName || 'Unknown User' }}</span>
                                    <span class="user-role">({{ item.role || 'Reviewer' }})</span>
                                </div>
                            </ng-template>
                        </app-tooltip>
                    </div>
                    <div class="history-footer">
                        <span class="remark">
                            {{ item.remark }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>
    } @else {
    <div class="requote-list">
        <div class="remarks-search-container">
            <app-input [formGroup]="searchForm" [controlName]="'search'" [placeholder]="'Search requotes'" [isSearchIcon]="true"
                [isClearIcon]="true" [label]="''">
            </app-input>
        </div>
        @if (filteredRequotes().length === 0) {
        <div class="empty-state">
            <span>No requotes found</span>
        </div>
        } @else {
        <mat-accordion>
            <div class="accordion-container">

                @for (requote of filteredRequotes(); track trackByRequoteRequestId($index, requote)) {
                <ng-container>


                    <mat-expansion-panel class="dependent-info" #panel="matExpansionPanel" [expanded]="$index === 0"
                        [hideToggle]="true" [class.dependent-info--accepted]="isAcceptedStatus(requote.status)"
                        [class.dependent-info--pending]="isPendingStatus(requote.status)"
                        [class.dependent-info--declined]="!isAcceptedStatus(requote.status) && !isPendingStatus(requote.status)">

                        <mat-expansion-panel-header class="custom-panel-header">


                            <div class="panel-text">
                                <mat-panel-title>

                                    <span class="requote-id">{{ requote.requestId }}</span>

                                </mat-panel-title>


                                <app-banner class="requote-status-banner" [variant]="getBannerVariant(requote.status)"
                                    [class.requote-status-banner--pending]="isPendingStatus(requote.status)"
                                    [iconName]="requote.status === 'Accepted' ? 'tick' : requote.status === 'Pending' ? 'icon-info-circle' : 'cross-in-circle-icon'"
                                    [message]="requote.status">
                                </app-banner>
                            </div>

                            <span class="custom-toggle">
                                <span class="expand-icon">{{ getPanelToggleIcon(panel.expanded) }}</span>
                            </span>


                        </mat-expansion-panel-header>

                        <div class="timeline">
                            @for (item of requote.history; track item.quoteId + '-' + item.dateTime; let last = $last) {
                            <div class="timeline-item" [class.last]="last">
                                <div class="timeline-rail">
                                    <span class="dot"></span>
                                    <span class="line"></span>
                                </div>

                                <div class="timeline-content">
                                    <div class="timeline-header">
                                        <div class="title-container">
                                            <span class="history-title">{{ item.title }}</span>
                                            <span class="requote-info">
                                                @if (item.quoteId) {
                                                <span class="history-quote-id">{{ item.quoteId }}</span>
                                                <div class="dot"></div>
                                                }
                                                <span>{{ formatDate(item.dateTime) }}</span>
                                                <div class="dot"></div>
                                                <span>{{ formatTime(item.dateTime) }}</span>
                                            </span>
                                        </div>
                                        <app-tooltip class="actor-img" [position]="'above'" [showDelay]="80" [hideDelay]="0">
                                            <img [src]="item.avatarUrl" class="avatar" alt="Actor avatar" />
                                            <ng-template #tooltipContent>
                                                <div class="user-details">
                                                    <span class="user-name">{{ item.actorName || 'Unknown User' }}</span>
                                                    <span class="user-role">({{ item.actorRole || 'Reviewer' }})</span>
                                                </div>
                                            </ng-template>
                                        </app-tooltip>
                                    </div>

                                    <div class="history-footer">
                                        <span class="reason-label">{{ item.reasonLabel }}</span>
                                    </div>

                                    <div class="reason-box">{{ item.reason }}</div>
                                </div>
                            </div>
                            }
                        </div>
                    </mat-expansion-panel>



                </ng-container>
                }

            </div>
        </mat-accordion>
        }

    </div>
    }
</div>
